module.exports = __webpack_public_path__ + "static/img/percentage90@2x.bf850a63.png";